import { GetAppEnvironmentService } from 'types/services';
import { m8API } from 'services/production/m8';
import {
  APP_ENVIRONMENT__PRODUCTION,
  APP_ENVIRONMENT__TESTING,
} from 'utils/appEnvironmentUtils';

export const getAppEnvironment: GetAppEnvironmentService = async () => {
  const environment = await m8API.auth.getEnvironmentServer();

  if (environment === APP_ENVIRONMENT__PRODUCTION) {
    return APP_ENVIRONMENT__PRODUCTION;
  }

  return APP_ENVIRONMENT__TESTING;
};
